import { signal } from '@preact/signals'
import type { DeliveryMode } from './platform'

/**
 * Как сейчас доставляются уведомления — общее состояние для всех площадок.
 * Живёт отдельно от самих площадок, чтобы строка о доставке не зависела от того,
 * сайт это, Telegram или приложение из магазина.
 */
export const deliveryMode = signal<DeliveryMode>('unknown')

/** Виден ли сервер-планировщик. В оболочке для магазина он не нужен и всегда «виден». */
export const serverReachable = signal(true)
